export const mainOptionsMock = [
    { id: 1, nombre: "Mi Empresa", url: "/mi-empresa", icono: 'bank', iconoPersonalizado: false },
    // { id: 2, nombre: "Parametro", url: "/parametro", icono: 'setting', iconoPersonalizado: false },
    { id: 3, nombre: "Mi Perfil", url: "/mi-perfil", icono: 'profile' },
    { id: 4, nombre: "Configuración", url: "/mi-configuracion", icono: 'file-pdf' },
    { id: 5, nombre: "Cambiar Contraseña", url: "/cambiar-contrasenia", icono: 'key' }
];